import React from 'react'
import PropTypes from 'prop-types'
import { List, Map } from 'immutable'
import {
  TYPE_CONTENT_SERIES,
  TYPE_CONTENT_VIDEO,
} from 'services/content-type'
import Link from 'components/Link'
import { getContentTags } from 'services/content'
import {
  TILE_V2_TAGS_SIZE_DEFAULT,
  TILE_V2_TAGS_SIZE_SMALL,
} from './constants'
import {
  getTileV2TagsClass,
  onClickTileTag,
} from './utils'

/**
 * List of tags for tiles and tile hover
 * @param {Object} props - The props
 * @param {String} props.contentType - The type of content
 * @param {String} props.size - The size of the tags, (default, small, etc)
 * @param {Map} props.data - The content data
 * @returns {JSX.Element} Tile tags component
 */
function TileV2Tags (props) {
  const {
    contentType,
    staticText,
    userLanguage,
    data,
    size,
  } = props
  const id = data.get('id')
  const url = data.get('url', '') || data.get('path', '')
  const references = List.isList(data.get('references')) ? data.get('references', List()) : List()
  const contentSubtype = data.get('contentSubtype')
  const displayType = data.get('displayType')
  const isNew = data.get('isNew', null)
  const hasNewEpisodes = data.get('hasNewEpisodes', false)
  const tags = getContentTags({
    tags: references,
    url,
    contentSubtype,
    isNew,
    hasNewEpisodes,
    contentType,
    staticText,
    userLanguage,
    displayType,
  }) || List()

  if ((contentType !== TYPE_CONTENT_SERIES && contentType !== TYPE_CONTENT_VIDEO)) {
    return null
  }

  if (tags.size <= 0 && size === TILE_V2_TAGS_SIZE_SMALL) {
    return (
      <div className="tile-v2__tags tile-v2__tags--spacer" />
    )
  }

  if (tags.size <= 0 && size !== TILE_V2_TAGS_SIZE_SMALL) {
    return null
  }

  return (
    <div className={getTileV2TagsClass({ baseClassName: 'tile-v2__tags', size })}>
      {
        tags.map((t) => {
          if (!Map.isMap(t)) {
            return null
          }

          return (
            <React.Fragment key={`${t}-${id}`}>
              {
                t.get('path')
                  ? <Link
                      to={t.get('path')}
                      className={getTileV2TagsClass({
                        baseClassName: 'tile-v2__tag',
                        size,
                        linked: true,
                        type: t.get('type'),
                      })}
                      onClick={() => onClickTileTag({ ...props, tagId: t.get('content_id'), tagName: t.get('name') })}
                    >
                      {t.get('name') || t.get('title')}
                    </Link>
                  : <span className={getTileV2TagsClass({ baseClassName: 'tile-v2__tag', size, type: t.get('type') })}>
                      {t.get('name') || t.get('title')}
                    </span>
              }
            </React.Fragment>
          )
        })
      }
    </div>
  )
}

TileV2Tags.propTypes = {
  size: PropTypes.string,
}

TileV2Tags.defaultProps = {
  size: TILE_V2_TAGS_SIZE_DEFAULT,
}

export default TileV2Tags
